export default {"src":"/customer-services/_next/static/media/guarantees.542eec1b.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};